import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import _ from 'lodash';

const InfoCalculadora = (props) => {
    const { } = props;

    
    return (
        <Grid container >
            <Grid item md={12} xs={12} style={{textAlign:'center',paddingTop:'0.8rem',paddingBottom:'1.5rem'}}>
                <h3 style={{fontWeight:'bold'}}>SERVICIO DE FLETE AÉREO</h3>
            </Grid>
            <Grid item md={6} xs={6}  style={{}}>
                <p style={{ fontWeight: 'bold' }}>Peso:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>4.05 kg</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p style={{ fontWeight: 'bold' }}>Valor FOB del producto:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>USD 175.75</p>
            </Grid>

            <Grid item md={6} xs={6} style={{marginTop:'2.2rem'}}>
                <p style={{ fontWeight: 'bold' }}>Tarifa de flete:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{marginTop:'2.2rem'}}>
                <p>USD 7.50 x Kg</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p style={{ fontWeight: 'bold' }}>Gasto operativo:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>USD 7.50 + IGV x embarque</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p style={{ fontWeight: 'bold' }}>Tarifa de reparto:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>USD 7.00 + IGV x embarque</p>
            </Grid>

            <Grid item md={6} xs={6} style={{marginTop:'2.2rem'}}>
                <p style={{ fontWeight: 'bold' }}>Flete:</p>
            </Grid>
            <Grid citem md={6} xs={6} style={{marginTop:'2.2rem'}}>
                <p>USD 30.38</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p style={{ fontWeight: 'bold' }}>Gasto operativo:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>USD 8.85 Incluido IGV</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p style={{ fontWeight: 'bold' }}>Reparto:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{}}>
                <p>USD 8.26 Incluido IGV</p>
            </Grid>

            <Grid item md={6} xs={6} style={{color:'#f87115',fontWeight: 'bold' ,marginTop:'0.8rem'}}>
                <p style={{}}>Total a pagar:</p>
            </Grid>
            <Grid item md={6} xs={6} style={{color:'#f87115', fontWeight: 'bold',marginTop:'0.8rem'}}>
                <p style={{}} >USD 47.49 Incluido IGV</p>
            </Grid>
        </Grid>
           
    )
}

export default InfoCalculadora;